<div *albertFeatureFlagDirective="'deployed_hash';">
  <p class="text-center">Currently Deployed Build Hash: 8986dfd</p>
  <p class="text-center">Please specify the Hash when reporting issues!</p>
</div>
